import {DisplayMinute} from "../../../directives/display.minute";
import {DisplayCurrency} from "../../../directives/display.currency";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";

export class UsagerBudget{

  employeeId: string;
  budgetInMinutes: number;
  budgetAmount:number;

  willBeUsedInDashboard(){
    if (this.budgetAmount>0){
      return true;
    }
    if (this.budgetInMinutes>0){
      return true;
    }
    return false;
  }

  explain(session:SessionService, translate: TranslateService):string{
      let res = '';
      if (this.willBeUsedInDashboard()){
        const dm = new DisplayMinute();
        const dc = new DisplayCurrency(translate);

        const budgetMin = dm.transform(this.budgetInMinutes);
        const budgetAmount = dc.transform(this.budgetAmount);

        if (session.canSeeAmount() && this.budgetAmount>0){
          return translate.instant('ExplainUsagerBudget',{budgetInMinutes: budgetMin,budgetAmount: budgetAmount})
        }else{
          return translate.instant('ExplainUsagerBudgetNoAmount',{budgetInMinutes: budgetMin})
        }
      }
      return res;
  }


}
